import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function clientPackagesListRequest(urlParams = {}) {
  let url = urls.clientPackagesList;

  if (urlParams.page) {
    url = urls.clientPackagesListPsf;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
  });
}

export async function clientPackagesItemRequest(urlParams = {}) {
  const url = urls.clientPackagesItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function clientPackagesCreateRequest(data) {
  return request({
    method: 'post',
    url: urls.clientPackagesCreate,
    data,
    headers: getHeaders(),
  });
}

export async function clientPackagesUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.clientPackagesUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function clientPackagesDeleteRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.clientPackagesDelete,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/clientPackages.js